import {
  TOGGLE_LOADING, 
  UNAUTHORIZED_SETTING,  
  FETCH_TOKEN,
  FETCH_TIMEZONE_LIST,
  FETCH_USER_LIST,
  FETCH_USER_DETAILS,
  NOTIFICATION_CHECK_LIST,
  FETCH_SCHEDULE_LIST,
  FETCH_BILLING_URL,
  FETCH_LOOKUP_KEY,
  FETCH_MANAGE_BILLING,
  FETCH_CALENDLY_URL,
  FETCH_EVENT_LIST,
  FETCH_EVENT_DETAIL,
  FETCH_GOOGLE_CALENDAR_URL,
  FETCH_EVENT_POPUP_LIST,
  CALENDLY_DATA,
  FETCH_CURRENT_PLAN,
  STRIPE_UPDATED_DATA,
  FIELDS_DATA,
  HUBSPOT_STATUS,
  HUBSPOT_SYNC_DATA,
  HUBSPOT_MAPPED_DATA,
  HUBSPOT_DELETE_DATA,
  FETCH_USER_DATA,
  FETCH_SELECTED_CALENDAR,
  ZOI_VISIBILITY,
  PLAN_DETAILS,
  INTEL_SETTING,
  PAYMENT_HISTORY,
  NOTIFICATION_DATA 
} from "../../constants/SettingActionTypes";


  const initialState = {
    loading: false,
    unAuthorisedSetting:null,
    fetchToken: null,
    fetchEventList: null,
    notification_check: null,
    fetchUserList: null,
    fetchEventDetail: null,
    fetchGoogleCalendarUrl: null,
    fetchScheduleList: null,
    fetchUserDetails: null,
    fetchTimeList: null,
    fetchSyncPopupList: null,
    fetchBillingUrl:null,
    fetchLookupKey:null,
    fetchManageBilling:null,
    fetchCurrentPlan:null,
    fetchCalendlyUrl:null,
    calendlyData:null,
    stripeUpdatedData:null,
    fieldsData:null,
    hubspotStatus: null,
    hubspotSyncData: null,
    hubspotMappedData:null,
    hubspotDeleteData:null,
    fetchUserData:null,
    fetchSelectedCalendar:null,
    fetchZoiVibility:null,
    planDetails:null,
    intelSetting:null,
    paymentHistory:null,
    notificationData:null

  }

  const settingReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
        return { ...state, loading: payload };
      case UNAUTHORIZED_SETTING:
        return { ...state, unAuthorisedSetting: payload };
      case FETCH_TOKEN:
        return { ...state, fetchToken: payload };
      case FETCH_SCHEDULE_LIST:
        return { ...state, fetchScheduleList: payload };
      case FETCH_EVENT_LIST:
        return { ...state, fetchEventList: payload };
      case FETCH_EVENT_DETAIL:
        return { ...state, fetchEventDetail: payload };
      case FETCH_USER_LIST:
        return { ...state, fetchUserList: payload };
      case FETCH_EVENT_POPUP_LIST:
        return { ...state, fetchSyncPopupList: payload };
      case FETCH_TIMEZONE_LIST:
        return { ...state, fetchTimeList: payload };
      case NOTIFICATION_CHECK_LIST:
        return { ...state, notification_check: payload };
      case FETCH_USER_DETAILS:
        return { ...state, fetchUserDetails: payload };
      case FETCH_BILLING_URL:
        return { ...state, fetchBillingUrl: payload };
      case FETCH_LOOKUP_KEY:
        return { ...state, fetchLookupKey: payload };
      case FETCH_MANAGE_BILLING:
        return { ...state, fetchManageBilling: payload };
      case FETCH_CURRENT_PLAN:
        return { ...state, fetchCurrentPlan: payload };
      case FETCH_CALENDLY_URL:
        return { ...state, fetchCalendlyUrl: payload };
      case CALENDLY_DATA:
        return { ...state, calendlyData: payload };
      case STRIPE_UPDATED_DATA:
        return { ...state, stripeUpdatedData: payload };
      case FIELDS_DATA:
        return { ...state, fieldsData: payload };
      case FETCH_GOOGLE_CALENDAR_URL:
          return { ...state, fetchGoogleCalendarUrl: payload };
      case HUBSPOT_STATUS:
        return { ...state, hubspotStatus: payload };
      case HUBSPOT_SYNC_DATA:
        return { ...state, hubspotSyncData: payload };
      case HUBSPOT_MAPPED_DATA:
        return { ...state, hubspotMappedData: payload };
      case HUBSPOT_DELETE_DATA:
        return { ...state, hubspotDeleteData: payload };
      case FETCH_USER_DATA:
        return { ...state, fetchUserData: payload };
      case FETCH_SELECTED_CALENDAR:
        return { ...state, fetchSelectedCalendar: payload };
      case ZOI_VISIBILITY:
        return { ...state, fetchZoiVibility: payload };
      case PLAN_DETAILS:
        return { ...state, planDetails: payload };
      case INTEL_SETTING:
        return { ...state, intelSetting: payload };
      case PAYMENT_HISTORY:
        return { ...state, paymentHistory: payload };
      case NOTIFICATION_DATA:
        return { ...state, notificationData: payload };
      default:
        return state;
    }
  };

  export default settingReducer;
